import React, {useCallback} from 'react'
import {FallbackProps} from 'react-error-boundary'

import {HProduceSuiteLogger} from '../../logger/HProduceSuiteLogger'

import {GenericErrorBoundary} from './GenericErrorBoundary'
import {GlobalErrorFallback} from './GlobalErrorFallback'

interface GlobalErrorBoundaryProps {
  children: React.ReactNode
}

export const GlobalErrorBoundary = ({children}: GlobalErrorBoundaryProps) => {
  const fallbackRender = useCallback(
    ({resetErrorBoundary}: FallbackProps) => (
      <GlobalErrorFallback resetErrorBoundary={resetErrorBoundary} />
    ),
    []
  )

  const onError = useCallback((error: Error, info: React.ErrorInfo) => {
    HProduceSuiteLogger.context('GlobalErrorBoundary', String(info.componentStack)).fatal(
      `${error.name}: ${error.message}`
    )
  }, [])

  return (
    <GenericErrorBoundary fallbackRender={fallbackRender} onError={onError}>
      {children}
    </GenericErrorBoundary>
  )
}
